<template>
  <header :class="$style.header">
    <div :class="$style.container">
      <div
        :class="[$style.left, { [$style.pointer]: isLogoClickable }]"
        @click="handleLogoClick"
      >
        <img src="/icons/common/logo.svg" alt="" />
      </div>
      <div :class="$style.right">
        <div
          v-if="$route.name === 'ticker'"
          :class="[$style.links, $style.desctop]"
        >
          <div :class="$style.link">
            ID орг: {{ supervision?.organization?.name }}
          </div>
          <div :class="$style.link">
            ID сотр: {{ supervision?.worker?.username }}
          </div>
          <div :class="$style.link">
            ID набл: {{ supervision?.user?.username }}
          </div>
        </div>
        <div v-if="$route.name !== 'analytics'" :class="$style.timer">
          {{ getTime }}
        </div>
        <div>
          <img
            @click.stop="logout"
            src="/icons/common/logout.svg"
            alt=""
            :class="$style.logout"
          />
        </div>
      </div>
    </div>
    <div v-if="$route.name === 'ticker'" :class="[$style.links, $style.mobile]">
      <div :class="$style.link">
        ID орг: {{ supervision?.organization?.name }}
      </div>
      <div :class="$style.link">
        ID сотр: {{ supervision?.worker?.username }}
      </div>
      <div :class="$style.link">ID набл: {{ supervision?.user?.username }}</div>
    </div>
  </header>
</template>

<script>
import { mapState } from "vuex";
import Repository from "@/repository";
export default {
  methods: {
    async logout() {
      this.$store.commit("stopTimer");
      await Repository.Auth.logout({ id: this.$route.params.id });
      this.$store.commit("clearUserData");
      Repository.connector.clearAuthHeaders();
      this.$router.push("/login");
    },
    async handleLogoClick() {
      if (this.$route.name === "ticker") {
        this.$router.push({ name: "analytics" });
      } else if (this.$route.name === "analytics") {
        let id = this.supervision?.id || this.lastSupervision?.id;
        if (!id) {
          id = await this.$store.dispatch("getOpenSupervision");
        }
        if (id) {
          this.$router.push({ name: "ticker", params: { id } });
        }
      }
    },
  },
  computed: {
    ...mapState({
      seconds: (state) => state.timer.seconds,
      supervision: (state) => state.supervision.supervision,
      lastSupervision: (state) => state.auth.lastSupervision,
    }),
    getTime() {
      const hours = String(Math.floor(this.seconds / 3600));
      const mins = String(Math.floor((this.seconds - hours * 3600) / 60));
      const secs = String(this.seconds % 60);
      return `${hours.padStart(2, "0")}:${mins.padStart(
        2,
        "0"
      )}:${secs.padStart(2, "0")} `;
    },
    isLogoClickable() {
      return ["ticker", "analytics"].includes(this.$route.name);
    },
  },
};
</script>

<style lang="scss" module>
.header {
  @include container;
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
  @include custom(1150) {
    padding-top: 1rem;
  }
  .container {
    display: flex;
    justify-content: space-between;
    gap: 1rem;
    align-items: center;
  }
  .left {
    font-weight: 800;
    font-size: 1.5rem;
    @include custom(380) {
      img {
        width: 8rem;
      }
    }
  }
  .right {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    @include custom(900) {
      gap: 1rem;
    }
    .timer {
      padding: 0.75rem 1.5rem;
      background-color: $blue;
      color: $t-white;
      border-radius: 1.5rem;
    }
    .logout {
      cursor: pointer;
    }
  }
}
.pointer {
  cursor: pointer;
}
.links {
  display: flex;
  gap: 1rem;
  .link {
    padding: 0.75rem 1.5rem;
    background-color: $bg-white;
    border-radius: 1.5rem;
    white-space: nowrap;
  }
  &.mobile {
    display: none;
  }
  @include custom(1200) {
    &.desctop {
      display: none;
    }
    &.mobile {
      display: flex;
      margin: 1rem 0 0 0;
      flex-wrap: wrap;
    }
  }
}
</style>
